import { AngularEditorConfig } from '@kolkov/angular-editor';

export const ModuleList = [
  {
    id: 1,
    key: 'dashboard',
    label: 'Dashboard',
    displayLabel: 'ui_sidebar_dashboard_lbl',
    icon: '../../../assets/icons/sidebar/piechart.svg',
    activeIcon: '../../../assets/icons/sidebar/piechart-active.svg',
    subItems: [],
    link: '/dashboard'
  },
  {
    id: 2,
    key: 'shop_listing',
    label: 'Shop Listing',
    displayLabel: 'ui_sidebar_shop_listing_lbl',
    icon: '../../../assets/icons/sidebar/shoplist.svg',
    activeIcon: '../../../assets/icons/sidebar/shoplist-active.svg',
    subItems: [
      { id: 21, key: 'shop', label: 'Shop', displayLabel: 'ui_sidebar_shop_lbl', link: '/uam/shop' },
      {
        id: 22,
        key: 'settlements',
        label: 'Settlements',
        displayLabel: 'ui_sidebar_settlements_lbl',
        link: '/uam/remittance'
      },
      {
        id: 23,
        key: 'support_ticket',
        label: 'Support Ticket Management',
        displayLabel: 'ui_sidebar_support_ticket_mngmt_lbl',
        link: '/uam/tickets'
      }
    ]
  },
  {
    id: 3,
    key: 'product_listing',
    label: 'Product Listing',
    displayLabel: 'ui_sidebar_prod_listing_lbl',
    icon: '../../../assets/icons/sidebar/product.svg',
    activeIcon: '../../../assets/icons/sidebar/product-active.svg',
    subItems: [
      {
        id: 31,
        key: 'collections',
        label: 'Collections',
        displayLabel: 'ui_sidebar_collections_lbl',
        link: '/product/collection'
      },
      { id: 32, key: 'products', label: 'Products', displayLabel: 'ui_sidebar_prod_lbl', link: '/product' },
      {
        id: 33,
        key: 'product_bundles',
        label: 'Product Bundles',
        displayLabel: 'ui_sidebar_prod_bundle_lbl',
        link: '/product/bundles'
      },
      { id: 34, key: 'tags', label: 'Tags', displayLabel: 'ui_sidebar_tag_lbl', link: '/product/tag' },
      {
        id: 35,
        key: 'inventory',
        label: 'Inventory',
        displayLabel: 'ui_sidebar_inventory_lbl',
        link: '/product/inventory'
      }
    ]
  },
  {
    id: 4,
    key: 'academic_store',
    label: 'Academic Store',
    displayLabel: 'ui_sidebar_academic_store_lbl',
    icon: '../../../assets/icons/sidebar/product.svg',
    activeIcon: '../../../assets/icons/sidebar/product-active.svg',
    subItems: [
      {
        id: 41,
        key: 'academic_collections',
        label: 'Academic Collections',
        displayLabel: 'ui_sidebar_academic_collections_lbl',
        link: '/academic-store/collections'
      },
      {
        id: 42,
        key: 'academic_products',
        label: 'Academic Products',
        displayLabel: 'ui_sidebar_academic_products_lbl',
        link: '/academic-store/products'
      },
      {
        id: 43,
        key: 'academic_educustomer',
        label: 'Academic eduCustomer',
        displayLabel: 'ui_sidebar_academic_educustomer_lbl',
        link: '/academic-store/educustomer'
      }
    ]
  },
  {
    id: 5,
    key: 'parties',
    label: 'Parties',
    displayLabel: 'ui_sidebar_parties_lbl',
    link: '/brands',
    icon: '../../../assets/icons/sidebar/star.svg',
    activeIcon: '../../../assets/icons/sidebar/star-active.svg',
    subItems: [
      { id: 51, key: 'brands', label: 'Brands', displayLabel: 'ui_sidebar_brands_lbl', link: '/brands' },
      { id: 52, key: 'vendors', label: 'Vendors', displayLabel: 'ui_sidebar_vendors_lbl', link: '/vendors' }
    ]
  },
  {
    id: 6,
    key: 'meals',
    label: 'Meals',
    displayLabel: 'ui_sidebar_meal_lbl',
    icon: '../../../assets/icons/sidebar/marketing.svg',
    activeIcon: '../../../assets/icons/sidebar/marketing-active.svg',
    subItems: [
      {
        id: 61,
        key: 'meal_subscription',
        label: 'Meals Subscription',
        displayLabel: 'ui_sidebar_meal_subs_lbl',
        link: '/meals'
      },
      {
        id: 62,
        key: 'meal_planner',
        label: 'Meals Planner',
        displayLabel: 'ui_sidebar_meal_planner_lbl',
        link: '/meals/planner'
      }
    ]
  },
  {
    id: 7,
    key: 'offers',
    label: 'Offers',
    displayLabel: 'ui_sidebar_offers_lbl',
    icon: '../../../assets/icons/sidebar/offer.svg',
    activeIcon: '../../../assets/icons/sidebar/offer-active.svg',
    subItems: [
      {
        id: 71,
        key: 'coupon_offers',
        label: 'Coupon Offers',
        displayLabel: 'ui_coupon_offers_lbl',
        link: '/offers'
      }
      // {
      //   id: 72,
      //   key: 'promotions',
      //   label: 'Promotions',
      //   displayLabel: 'ui_sidebar_promotions_lbl',
      //   link: '/offers/promotions'
      // }
    ]
  },
  {
    id: 9,
    key: 'orders',
    label: 'Orders',
    icon: '../../../assets/icons/sidebar/order.svg',
    displayLabel: 'ui_sidebar_orders_lbl',
    activeIcon: '../../../assets/icons/sidebar/order-active.svg',
    subItems: [
      {
        id: 91,
        key: 'process_orders',
        label: 'Process Orders',
        displayLabel: 'ui_sidebar_process_orders_lbl',
        link: '/process-orders/process-listing-v2'
      },
      {
        id: 92,
        key: 'track_orders',
        label: 'Track Orders',
        displayLabel: 'ui_sidebar_track_orders_lbl',
        link: '/orders'
      },
      {
        id: 97,
        key: 'prebook_orders',
        label: 'Pre-Book Orders',
        displayLabel: 'ui_sidebar_prebook_orders_lbl',
        link: '/orders/prebook-orders'
      },
      { id: 93, key: 'ndr', label: 'NDR', displayLabel: 'ui_sidebar_ndr_lbl', link: '/orders/ndr' },
      {
        id: 94,
        key: 'return_request',
        label: 'Return Request',
        displayLabel: 'ui_sidebar_return_req_lbl',
        link: '/orders/return-request-v2'
      },
      {
        id: 95,
        key: 'rto_returns',
        label: 'RTO & Returns',
        displayLabel: 'ui_sidebar_rto_return_lbl',
        link: '/orders/rto'
      },
      {
        id: 96,
        key: 'abandoned_cart',
        label: 'Abandoned Cart',
        displayLabel: 'ui_sidebar_abandon_cart_lbl',
        link: '/orders/abandoned-cart'
      }
    ]
  },
  {
    id: 10,
    key: 'pos',
    label: 'POS',
    displayLabel: 'ui_sidebar_pos_lbl',
    icon: '../../../assets/icons/sidebar/pos.svg',
    isNew: true,
    activeIcon: '../../../assets/icons/sidebar/pos-active.svg',
    subItems: [
      { id: 101, key: 'new_sale', label: 'New Sale', displayLabel: 'ui_sidebar_new_sale_lbl', link: '/sales/new-sale' },
      { id: 102, key: 'sale_list', label: 'Sale List', displayLabel: 'ui_sidebar_sale_list_lbl', link: '/sales/list' },
      {
        id: 103,
        key: 'transaction',
        label: 'Transaction',
        displayLabel: 'ui_sidebar_transaction_lbl',
        link: '/sales/transaction'
      }
    ]
  },
  {
    id: 11,
    key: 'customers',
    label: 'Customers',
    displayLabel: 'ui_sidebar_customers_lbl',
    icon: '../../../assets/icons/sidebar/customer.svg',
    activeIcon: '../../../assets/icons/sidebar/customer-active.svg',
    subItems: [
      { id: 111, key: 'customer', label: 'Customer', displayLabel: 'ui_sidebar_customer_lbl', link: '/customers' },
      {
        id: 112,
        key: 'customer_group',
        label: 'Customer Group',
        displayLabel: 'ui_sidebar_customer_group_lbl',
        link: '/customers/customer-group'
      },
      {
        id: 113,
        key: 'customer_feedback',
        label: 'Customer Feedback',
        displayLabel: 'ui_sidebar_customer_feedback_lbl',
        link: '/reviews'
      },
      {
        id: 114,
        key: 'subscriber',
        label: 'Subscriber',
        displayLabel: 'ui_sidebar_customer_sub_lbl',
        link: '/customers/subscribed'
      }
    ]
  },
  {
    id: 12,
    key: 'website',
    label: 'Website',
    displayLabel: 'ui_sidebar_Website_lbl',
    icon: '../../../assets/icons/sidebar/website.svg',
    activeIcon: '../../../assets/icons/sidebar/website-active.svg',
    subItems: [
      { id: 121, key: 'themes', label: 'Themes', displayLabel: 'ui_sidebar_theme_lbl', link: '/appearance/themes' },
      {
        id: 122,
        key: 'content_management',
        label: 'Content Management',
        displayLabel: 'ui_sidebar_cntent_mng_lbl',
        link: '/content-studio'
      },
      {
        id: 123,
        key: 'page_builder',
        label: 'Page Builder',
        displayLabel: 'ui_sidebar_page_build_lbl',
        link: '/cms/page-builder'
      },
      { id: 124, key: 'blog', label: 'Blog', displayLabel: 'ui_sidebar_blog_lbl', link: '/appearance/blogs' },
      { id: 125, key: 'page', label: 'Page', displayLabel: 'ui_sidebar_page_lbl', link: '/appearance/pages' },
      {
        id: 126,
        key: 'announcement_bar',
        label: 'Announcement Bar',
        displayLabel: 'ui_sidebar_announceMent_bar_lbl',
        link: '/appearance/announcement-bar'
      },
      { id: 127, key: 'navbar', label: 'Navbar', displayLabel: 'ui_sidebar_navbar_lbl', link: '/appearance/navbar' },
      { id: 128, key: 'footer', label: 'Footer', displayLabel: 'ui_sidebar_footer_lbl', link: '/appearance/footer' }
    ]
  },
  {
    id: 17,
    key: 'channel_partners',
    label: 'Channel Partners',
    displayLabel: 'ui_sidebar_channel_partners_lbl',
    link: '/channel-partners',
    icon: '../../../assets/icons/sidebar/channel-partners.svg',
    activeIcon: '../../../assets/icons/sidebar/channel-partners-active.svg',
    subItems: []
  },
  {
    id: 13,
    key: 'marketing',
    label: 'Marketing',
    displayLabel: 'ui_sidebar_market_lbl',
    icon: '../../../assets/icons/sidebar/marketing.svg',
    activeIcon: '../../../assets/icons/sidebar/marketing-active.svg',
    subItems: [
      {
        id: 131,
        key: 'remarketing',
        label: 'Remarketing',
        displayLabel: 'ui_sidebar_remarket_lbl',
        link: '/marketing'
      },
      {
        id: 132,
        key: 'campaign',
        label: 'Campaign',
        displayLabel: 'ui_sidebar_campaign_lbl',
        link: '/marketing/campaign'
      },
      {
        id: 133,
        key: 'referral',
        label: 'Referral',
        displayLabel: 'ui_sidebar_referrals_lbl',
        link: '/marketing/referrals'
      }
    ]
  },
  {
    id: 14,
    key: 'finances',
    label: 'Finances',
    displayLabel: 'ui_sidebar_finance_lbl',
    icon: '../../../assets/icons/sidebar/finance.svg',
    activeIcon: '../../../assets/icons/sidebar/finance-active.svg',
    subItems: [
      {
        id: 141,
        key: 'remittance',
        label: 'Remittance',
        displayLabel: 'ui_sidebar_remittance_lbl',
        link: '/finance/remittance'
      },
      {
        id: 142,
        key: 'billing_invoice',
        label: 'Billing Invoice',
        displayLabel: 'ui_sidebar_billing_lbl',
        link: '/finance/billing-invoice'
      }
    ]
  },
  {
    id: 15,
    key: 'plugins',
    label: 'Plugins',
    link: '/plugins',
    displayLabel: 'ui_sidebar_plugins_lbl',
    isNew: true,
    icon: '../../../assets/icons/sidebar/plugins.svg',
    activeIcon: '../../../assets/icons/sidebar/plugins-active.svg',
    // Both sub-items are gated on `plugins.view` (the sidebar filters sub-items by key).
    subItems: [
      { id: 151, key: 'plugins', label: 'All plugins', displayLabel: 'ui_sidebar_all_plugins_lbl', link: '/plugins' },
      {
        id: 152,
        key: 'plugins',
        label: 'Connected apps',
        displayLabel: 'ui_sidebar_connected_apps_lbl',
        link: '/plugins/connected-apps'
      }
    ]
  },
  {
    id: 16,
    key: 'customer_support',
    label: 'Customer Support',
    displayLabel: 'ui_sidebar_customer_support_lbl',
    link: '/customer-support',
    icon: '../../../assets/icons/sidebar/support.svg',
    activeIcon: '../../../assets/icons/sidebar/support-active.svg',
    subItems: []
  }
];

export const timingData = [
  {
    label: '12:00 AM',
    value: '12:00 AM'
  },
  {
    label: '1:00 AM',
    value: '1:00 AM'
  },
  {
    label: '2:00 AM',
    value: '2:00 AM'
  },
  {
    label: '3:00 AM',
    value: '3:00 AM'
  },
  {
    label: '4:00 AM',
    value: '4:00 AM'
  },
  {
    label: '5:00 AM',
    value: '5:00 AM'
  },
  {
    label: '6:00 AM',
    value: '6:00 AM'
  },
  {
    label: '7:00 AM',
    value: '7:00 AM'
  },
  {
    label: '8:00 AM',
    value: '8:00 AM'
  },
  {
    label: '9:00 AM',
    value: '9:00 AM'
  },
  {
    label: '10:00 AM',
    value: '10:00 AM'
  },
  {
    label: '11:00 AM',
    value: '11:00 AM'
  },
  {
    label: '12:00 PM',
    value: '12:00 PM'
  },
  {
    label: '1:00 PM',
    value: '1:00 PM'
  },
  {
    label: '2:00 PM',
    value: '2:00 PM'
  },
  {
    label: '3:00 PM',
    value: '3:00 PM'
  },
  {
    label: '4:00 PM',
    value: '4:00 PM'
  },
  {
    label: '5:00 PM',
    value: '5:00 PM'
  },
  {
    label: '6:00 PM',
    value: '6:00 PM'
  },
  {
    label: '7:00 PM',
    value: '7:00 PM'
  },
  {
    label: '8:00 PM',
    value: '8:00 PM'
  },
  {
    label: '9:00 PM',
    value: '9:00 PM'
  },
  {
    label: '10:00 PM',
    value: '10:00 PM'
  },
  {
    label: '11:00 PM',
    value: '11:00 PM'
  }
];

export const CONSTANTS = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE'
};
export const softwareVersion = '2026 v2';

export const GlobalEditorConfig: AngularEditorConfig = {
  editable: true,
  spellcheck: false,
  height: '15rem',
  minHeight: '5rem',
  placeholder: 'Enter text here...',
  translate: 'no',
  defaultParagraphSeparator: 'p',
  defaultFontName: 'Arial',
  toolbarHiddenButtons: [['bold', 'textColor', 'backgroundColor', 'customClasses']]
};
